(function () {
  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  headers.forEach(function (header) {
    // Cart drawer toggle — header cart button(s) open the cart drawer.
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }

    // Folded mobile menu — drawer below the native header, color-inverts header.
    var menuToggle = header.querySelector('.oddit-header__menu-toggle');
    var panel = header.querySelector('.oddit-header__mobile-menu');
    var toggleLabel = menuToggle ? menuToggle.querySelector('span') : null;
    var openLabel = toggleLabel ? toggleLabel.textContent : 'Menu';
    var closeLabel = 'Close';

    function syncHeaderHeight() {
      if (!panel) return;
      // Use the header's bottom edge so the offset includes anything sitting above
      // it in the document flow (e.g. the announcement bar) while it's still visible.
      var offset = Math.max(0, header.getBoundingClientRect().bottom);
      panel.style.setProperty('--oddit-header-height', offset + 'px');
    }

    function openPanel() {
      if (!panel) return;
      syncHeaderHeight();
      panel.hidden = false;
      // Force a reflow so the transition runs from the hidden state.
      void panel.offsetWidth;
      panel.classList.add('oddit-header__mobile-menu--open');
      panel.setAttribute('aria-hidden', 'false');
      header.classList.add('oddit-header--menu-open');
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'true');
        menuToggle.setAttribute('aria-label', 'Close menu');
        if (toggleLabel) toggleLabel.textContent = closeLabel;
      }
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function closePanel() {
      if (!panel) return;
      panel.classList.remove('oddit-header__mobile-menu--open');
      panel.setAttribute('aria-hidden', 'true');
      header.classList.remove('oddit-header--menu-open');
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
        if (toggleLabel) toggleLabel.textContent = openLabel;
      }
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      // Re-hide after the fade-out transition completes.
      window.setTimeout(function () {
        if (!panel.classList.contains('oddit-header__mobile-menu--open')) {
          panel.hidden = true;
        }
      }, 220);
    }

    if (menuToggle && panel) {
      menuToggle.addEventListener('click', function () {
        var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
        if (expanded) closePanel(); else openPanel();
      });
    }

    window.addEventListener('resize', function () {
      if (panel && panel.classList.contains('oddit-header__mobile-menu--open')) {
        syncHeaderHeight();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('oddit-header__mobile-menu--open')) {
        closePanel();
      }
    });
  });

  // Live cart count badge — listens for the global cart:updated event.
  document.addEventListener('cart:updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
    }
  });
})();